import { render, staticRenderFns } from "./PdpProductImagePanel.vue?vue&type=template&id=8fda98c0&"
import script from "./PdpProductImagePanel.vue?vue&type=script&lang=js&"
export * from "./PdpProductImagePanel.vue?vue&type=script&lang=js&"
import style0 from "./PdpProductImagePanel.vue?vue&type=style&index=0&id=8fda98c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports